export namespace OrderConstant {
  export const ESTIMATED_SERVICE_FEE = 10;
}
